<script>
import { mapActions } from 'vuex'
import { add, edit } from '@/api/acessorelatorio'
import fields from './fields'
import { setFocus } from '@/services/crud'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data: () => ({
    fields,
    form: {}
  }),
  methods: {
    ...mapActions({
      toaster: 'modal/toaster',
      editaRelatorio: 'relatorio/editaRelatorio'
    }),
    focuInicial () {
      setFocus('input[type="text"]', this.$refs.form.$el)
    },
    refresh (data) {
      this.form = JSON.parse(JSON.stringify(data))
      this.trataJson(JSON.parse(JSON.stringify(data)))
      if (!this.form.id) this.$refs.form.instance.resetValues()
      this.focuInicial()
    },
    trataJson (data) {
      // Filtros
      if (this.form.filtros) {
        try {
          let filtros = JSON.parse(this.form.filtros)
          this.form.filtros = JSON.stringify(filtros, undefined, 2)
        } catch (e) {
          this.form.filtros = data.filtros
        }
      }
      // Report
      if (this.form.report) {
        try {
          let report = JSON.parse(this.form.report)
          this.form.report = JSON.stringify(report, undefined, 2)
        } catch (e) {
          this.form.report = data.report
        }
      }
    },
    trataDados () {
      let dados = JSON.parse(JSON.stringify(this.form))
      return dados
    },
    async openRelatorio () {
      let dados = this.trataDados()
      await this.editaRelatorio({ layout: dados.report || null, function: this.setReportValue })
      this.$router.push('edita-relatorio')
    },
    async setReportValue (value) {
      this.form.report = value
    },
    async salvar () {
      // Salvar Editar
      try {
        let valida = this.$refs.form.instance.validate()
        if (!valida.isValid) throw new Error('Campos Inválidos')
        let data = {}
        let dados = this.trataDados()
        if (dados.id) {
          data = await edit(dados.id, dados)
          this.toaster({ message: 'Editado com sucesso!', color: 'success' })
        } else {
          data = await add(dados)
          this.toaster({ message: 'Adicionado com sucesso!', color: 'success' })
        }
        this.$emit('save', data)
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
      }
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar">
      <app-acessotela-select slot="fieldTela" slot-scope="data" :model="form.tela" @change="v => form.tela = v" />
      <app-acessofuncionalidade-select slot="fieldFuncionalidade" slot-scope="data" :model="form.funcionalidade" @change="v => form.funcionalidade = v" />
      <div slot="fieldReport" slot-scope="data">
        <div class="field-report">
          <div class="label">Report:</div> <dx-button icon="edit" @click="openRelatorio" />
          <dx-text-area :height="150" :value.sync="form.report" />
        </div>
      </div>
    </dx-form>
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style>
  .field-report .label {
    float: left;
    width: 45px;
  }
  .field-report .dx-button {
    margin-top: -7px;
    margin-bottom: 5px;
  }
  .field-report .dx-button-content {
    float: left;
    padding: 2px 4px 6px;
  }
</style>

<style scoped>
  .card-form {
    text-align: left;
  }
</style>
